<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-12-01 16:39:23
 * @LastEditors: jordan.lu jordan.lu@oppo.com
 * @LastEditTime: 2024-06-21 14:29:28
 * @FilePath: \sns-user-frontend\src\components\web\chat\index.vue
 * @Description: 关注/粉丝列表
-->
<template>
  <Drawer v-model="visible" :appendToBody="false" class="chat-drawer">
    <div class="chat-room">
      <div class="title-wrap">
        <span class="title">{{ chatTargetInfo.nickname }}</span>
        <el-popover
          v-if="blockType === 3"
          trigger="click"
          placement="bottom-end"
          :teleported="false"
        >
          <template #reference>
            <SvgIcon name="icon-more" />
          </template>
          <dl 
            class="chat-bar-more"
          >
            <dt @click="modifyChatSetting">{{ $t(`chat.${alreadyBlock ? 'openReceive' : 'closeReceive'}`) }}</dt>
          </dl>
        </el-popover>
      </div>
      <el-scrollbar wrap-class="chat-scroll" :height="`${hasBeenBlocked ? 'calc(100vh - var(--orbit-notice-height, 0px) - var(--orbit-nav-height) - 104px - 58px - 51px - 48px)' : 'calc(100vh - 400px - var(--orbit-notice-height, 0px) - var(--orbit-nav-height))'}`" always ref="scrollbar">
        <van-list
          v-model:loading="loading" 
          @load="onCheckPastMsg"
          :finished="finished"
          :error-text="$t('error')"
          :loading-text="$t('loading')"
          :immediate-check="false"
          direction="up"
        > 
          <div
            v-for="item in chatList"
            :key="item.id"
            class="msg-item"
            :class="item.fuid === userInfo.uid ? 'flex-end' : ''"
            @mouseenter="item.hover = true"
            @mouseleave="item.hover = false"
          >
            <p v-if="item.timeQuantum" class="msg-item-time"> {{ item.timeQuantum}} </p>
            <div 
              class="msg-item-info" 
              :class="item.fuid === userInfo.uid ? 'reverse' : ''"
            >
              <Avatar
                v-if="item.avatar" 
                :avatarInfo="{
                  avatar: item.avatar,
                  icon: item.icon,
                  id: item.fuid
                }"
                :size="48"
                :iconSize="13"
              />
              <div class="avatar-block" v-else></div>
              <div class="info"
                :class="[
                  item.fuid === userInfo.uid ? 'reverse' : ''
                ]"
              >
                <div v-if="item.attachments" class="private-image-box">
                  <div class="private-image-box-t">
                    <SvgIcon v-if="item.status === 'fail'" name="icon-error" />
                    <div class="private-image"
                      :style="{
                        width:  `${item.attachments?.[0].width}px`,
                        height: `${item.attachments?.[0].height}px`
                      }"
                    >
                      <div v-if="item.status && item.status !== 'complete'" class="layer"></div>
                      <ObImg 
                        v-if="item.attachments?.[0].id" 
                        fit="contain"
                        :crop="item.attachments?.[0].crop"
                        :src="item.attachments[0]?.url" 
                        :formatWidth="item.attachments?.[0].formatWidth"
                        :formatHeight="item.attachments?.[0].formatHeight"
                        :style="{
                          height: `${item.attachments?.[0].height}px`
                        }"
                        @click="onPreview(item.attachments[0].url)"
                      />
                      <img 
                        v-if="!item.attachments?.[0].id && item.attachments?.[0].height"  
                        class="local-img" 
                        :src="item.attachments[0]?.url"
                        :style="{
                          height: `${item.attachments?.[0].height}px`
                        }"
                      >
                      <van-circle
                        v-if="item.status === 'progress'"
                        v-model:current-rate="item.progress"
                        :rate="item.progress"
                        :speed="100"
                        size="26px"
                        stroke-width="80"
                        color="#FFF"
                        layer-color="transparent"
                      />
                    </div>
                  </div>
                  <p v-if="item.status !== 'complete'">{{ item.msg }}</p>
                </div>
                <span
                  v-else
                  class="content" 
                  :class="item.fuid === userInfo.uid ? '' : 'chat-mate'"
                  v-html="XssFilter(item.msg, {
                    a: ['href', 'data-type', 'target']
                  })"
                ></span>
                <el-popover
                  v-if="item.id"
                  trigger="click"
                  placement="bottom"
                  :teleported="false"
                >
                  <template #reference>
                    <div class="pop-trigger">
                      <SvgIcon v-if="item.hover" name="icon-more" />
                    </div>
                  </template>
                  <dl 
                    class="chat-bar-more"
                  >
                    <dt
                      v-for="option in moreOptions(item)"
                      :key="option.value"
                      @click="onAction(option, item)"
                    >{{option.name}}</dt>
                  </dl>
                </el-popover>
              </div>
            </div>
          </div>
        </van-list> 
      </el-scrollbar>
      <div class="blocked-wrap" v-if="hasBeenBlocked">
        {{ $t('chat.needAuthForChat') }}
      </div>
      <div class="send-wrap" v-else>
        <el-input 
          type="textarea"
          maxlength="2000"
          v-model="chatValue"
          resize="none"
          :placeholder="$t('sendMessage')"
          :autosize="{ minRows: 1, maxRows: 5 }"
          id="emojiInput"
        />
        
        <div class="send-wrap-b">
          <div class="message-plugins">
            <el-popover placement="top-start"  trigger="click">
              <template #reference>
                <div class="emoji-bar"><SvgIcon name="icon-emoji" /></div>
              </template>
              <EmojiBox @selectEmoji="selectEmoji" :isTinymce="false"/>
            </el-popover>
            <van-uploader
              v-if="allowSendImage"
              v-model="attachments"
              ref="imageUploader"
              accept="image/*"
              :deletable="false"
              :preview-image="false"
              :after-read="afterSelectImage"
            >
              <SvgIcon name="icon-image" />
            </van-uploader>
          </div>
          <ObButton
            :disabled="!chatValue.trim()"
            :text="$t('send')"
            :callBack="sendMsg"
            :loading="sending"
          />
        </div>
      </div>
    </div>
  </Drawer>
  <Dialog 
    v-model:visible="showDeleteConfirm"
    :confirmText="$t('yes')"
    @onConfirm="onDelete"
  >
    <p class="delete-content">{{$t('deleteChat')}}</p>
  </Dialog>
  <Report v-model="reportVisible" type="5" :reportId="reportId"/>
  <WebImgPreview 
    v-model:visible="showPreview"
    :previewList="showList"
    :previewIndex="previewIndex"
  />
</template>

<script setup>
import UploadFile from '@/hooks/upload'
import XssFilter from '@/utils/xssFilter'

import Drawer from '../drawer'
import Avatar from '../../avatar'

import http from '@/service'

import { useUserStore } from '@/stores/user'
import { useSystemStore } from '@/stores/system'

import { $debounce, $throttle } from '@/utils/lodashFuncs'

import { watch, ref, nextTick, getCurrentInstance, computed, watchEffect } from 'vue';
import { storeToRefs } from 'pinia';

import { encrypt, aesInfo, aesDecrypt, aesEncrypt } from '@/utils/encrypt'
import { getImageDimensions } from '@/utils'

import EmojiBox from '@/components/web/emojiBox'
import { isArray } from 'lodash'

import RequestQueue from '@/utils/requestQueue'

const { proxy } = getCurrentInstance()

const queue = new RequestQueue();

const userStore = useUserStore()
const systemStore = useSystemStore()

const { userInfo, uid } = storeToRefs(userStore)
const { isWeb } = storeToRefs(systemStore)

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  chatInfo: {
    type: Object,
    default: {}
  }
})

const reportId = ref('')
const reportVisible = ref(false)
const scrollbar = ref(null)
const visible = ref(false)
// 列表状态控制
const loading = ref(false);   // 加载状态
const finished = ref(false);   // 总列表加载完成状态

const sending = ref(false)

const showDeleteConfirm = ref(false)

const blockType = ref(null)

const hasBeenBlocked = ref(false)

const alreadyBlock = ref(false)

const chatTargetInfo = ref(null)
const chatList = ref([])

const chatGourpId = ref('')

const chatValue = ref('')

const fetchTime = ref('')


const interval = ref(null)

const actionItem = ref({})

const attachments = ref([])

const allowSendImage = ref(true)

const showPreview = ref(false)
const showList = ref([])
const previewIndex = ref(0)

const moreOptions = (item) => {
  let defalut = [{
    name: proxy.$t('delete'),
    value: 'delete'
  }]
  if (item.fuid !== uid.value) {
    defalut.push({
      name: proxy.$t('report'),
      value: 'report',
    })
  }
  return defalut
}

function onPreview (url) {
  showList.value = [url]
  showPreview.value = true
}

// 选择的emoji
const selectEmoji = (item) => {
  const myInput = document.getElementById("emojiInput");
  //光标位置
  const startPos = myInput.selectionStart;
  const endPos = myInput.selectionEnd;
  //添加到光标位置
  const emoji = item;
  const inputTxt = myInput.value;
  const result = inputTxt.substring(0, startPos) + emoji + inputTxt.substring(endPos);
  myInput.value = result;
  //重新定位光标位置
  myInput.selectionStart = startPos + emoji.length;
  myInput.selectionEnd = startPos + emoji.length;
  myInput.focus();
  //赋值
  chatValue.value = result
}

const scrollToBottom = () => {
  const { scrollHeight, clientHeight } = document.querySelector('.chat-scroll')
  const bottom = scrollHeight - clientHeight
  scrollbar.value.setScrollTop(bottom)
}

const formatChatList = (chatMsgList) => {
  let list = JSON.parse(JSON.stringify(chatMsgList))
  if (!list.length) return []
  const { avatar: userAvatar, uid: userId } = userInfo.value
  const { avatar: chatUserAvatar, iconLink: chatUserIcon } = chatTargetInfo.value
  let calcTime = 300000 // 5分钟范围内为一个对话周期
  let chatTime = list[0].ctime
  list = list.reduce((prev, next) => {
    if (!prev.length) {
      next.avatar = next.fuid === userId ? userAvatar : chatUserAvatar 
      next.icon = next.fuid === userId ? userInfo.value.userIconVO?.iconLink : chatUserIcon 
      next.timeQuantum = proxy.$timeFormat(chatTime)
    } else {
      const residual = Number(next.ctime) - Number(chatTime)
      const nearlyFiveMinutes = residual >= 0 && residual <= calcTime
      if (!nearlyFiveMinutes) {
        next.timeQuantum = proxy.$timeFormat(next.ctime)
        chatTime = next.ctime
      }
      const lastSameChat = prev.reverse().find(p => !!p.avatar)
      prev.reverse()
      if (lastSameChat.fuid !== next.fuid || next.timeQuantum) {
        next.avatar = next.fuid === userId ? userAvatar : chatUserAvatar 
        next.icon = next.fuid === userId ? userInfo.value.userIconVO?.iconLink : chatUserIcon 
      }
    }
    next.attachments?.forEach(i => {
      if (i.alreadyCalculateRatio) return
      const ratio = i.height / i.width
      // if (i.id.includes('1845807422308876296')) {
      //   debugger
      // }
      i.width = i.width > 240 ? 240 : i.width
      if (i.height >= 16383) {
        i.height = 16383 / 2
      } else {
        i.formatWidth = i.width > 240 ? 240 * 4 : i.width * 4

      }
      if (i.width >= 240) {
        i.height = ratio * i.width
        i.formatHeight = i.height
      }
      if (i.height > 400) {
        i.crop = `w_${i.width},h_400,g_center`
        i.formatHeight = i.height
        i.height = i.id ? 400 : '100%'
      }
      // i.height = ratio * 240
      if (i.id) {
        let src = `${i.url}?appCode=community&t=${Date.now()}`
        if (import.meta.env.VITE_ENV === 'DEV') {
          try {
            let url = new URL(i.url)
            src = `${location.origin}${src.includes('proxy') ? '' : '/proxy'}${url.pathname}?appCode=community&t=${Date.now()}` 
          } catch {}
        }
        i.url = src
      }
      i.alreadyCalculateRatio = true
    })
    prev.push(next)
    return prev
  }, [])
  return list
}

const getNewChatList = async (time, type) => {
  const response = await http.getNewChatMsg({
    gid: chatGourpId.value,
    direction: type || 1,
    size: 20,
    time,
    key: encrypt(`${aesInfo.iv}${aesInfo.key}`)
  })
  if (response.code === 200) {
    response.data.chatUserMsg?.chatMsgList?.forEach(i => {
      const msg = aesDecrypt(i.msg, aesInfo.key, aesInfo.iv)
      i.msg = linkifyText(msg)
    })
  } else {
    proxy.$toast({
      message: response.msg
    })
  }
  return response
}

const linkifyText = (text) => {
  const msg = XssFilter(text)
  const pattern = /(https?:\/\/[^\s\u4e00-\u9fa5]+)/g;
  return msg.replace(pattern, '<a href="$1" target="_blank" data-type="link">$1</a>');
}

const onCheckPastMsg = $throttle(async () => {
  const time = chatList.value.length ? chatList.value[0].ctime : fetchTime.value
  const { code, data, msg } = await getNewChatList(time)
  if (code === 200) {
    let { chatMsgList } = data.chatUserMsg
    chatMsgList = formatChatList(chatMsgList)
    chatList.value = [ ...chatMsgList, ...chatList.value]
    finished.value = chatMsgList.length < 20
    fetchTime.value = data.currentTime
  } else {
    finished.value = true
  }
  loading.value = false
}, 300, {
  leading: false,
  trailing: true
})

const loopNewList = async () => {
  if (loading.value || sending.value) return
  const { code, data, msg } = await getNewChatList(fetchTime.value, 2)
  if (code === 200) {
    let { chatMsgList } = data.chatUserMsg
    if (chatMsgList?.length) {
      chatMsgList = formatChatList([  ...chatList.value, ...chatMsgList])
      chatList.value = [  ...chatMsgList]
    }
    fetchTime.value = data.currentTime
  }
  loading.value = false
}

const getChatList = async () => {
  const { code, data, msg } = await http.getChatList({
    tuid: chatTargetInfo.value.uid,
    key: encrypt(`${aesInfo.iv}${aesInfo.key}`)
  }) 
  if (code === 200 && data) {
    data.chatUserMsg?.chatMsgList?.forEach(i => {
      const msg = aesDecrypt(i.msg, aesInfo.key, aesInfo.iv)
      i.msg = linkifyText(msg)
    })
    const { id, chatUserMsg, blocked, chatSetting, sendImageSwitch } = data
    chatGourpId.value = id
    let { chatMsgList = [] } = chatUserMsg || {}
    chatMsgList = formatChatList(chatMsgList)
    chatList.value = [ ...chatList.value, ...chatMsgList ]
    fetchTime.value = data.currentTime
    finished.value = chatMsgList.length < 10
    hasBeenBlocked.value = blocked
    alreadyBlock.value = chatSetting.inList
    blockType.value = chatSetting.blockType
    allowSendImage.value = sendImageSwitch
    console.log(blockType.value)
    nextTick(() => {
      loopNewList()
      interval.value = setInterval(() => {
        loopNewList()
      }, 15000)
      setTimeout(() => {
        scrollToBottom()
      }, 0);
    })
  } else {
    proxy.$toast({
      message: msg
    })
  }
}



async function sendMsg () {
  sending.value = true
  let params = {
    gid: chatGourpId.value,
    msg: aesEncrypt(chatValue.value, aesInfo.key, aesInfo.iv),
    tuid: chatTargetInfo.value.uid,
    key: encrypt(`${aesInfo.iv}${aesInfo.key}`)
  }
  if (chatList.value.length) {
    params.preTime = chatList.value[chatList.value.length - 1].ctime
  }
  console.log(Date.now())
  const { code, data, msg } = await http.sendMsg(params)

  if (code === 200) {
    chatValue.value = ''
    data.chatUserMsg.chatMsgList.forEach(i => {
      const msg = aesDecrypt(i.msg, aesInfo.key, aesInfo.iv)
      i.msg = linkifyText(msg)
    })
    let { chatMsgList } = data.chatUserMsg
    chatMsgList = formatChatList([  ...chatList.value, ...chatMsgList])
    
    chatList.value = [  ...chatMsgList]
    fetchTime.value = data.currentTime
    nextTick(() => {
      scrollToBottom()
    })
  }
  if (code !== 200){
    proxy.$toast({
      message: msg
    })
  }
  sending.value = false
}


const onAction = ({value, name}, item) => {
  actionItem.value = item
  if (item.attachments) {
    proxy.$ga('message_user_image_operate', {
      "button_name": name
    })
  }
  
  if (value === 'delete') {
    showDeleteConfirm.value = true
  } else {
    reportVisible.value = true
    reportId.value = item.id
  }
}

const onDelete = $debounce(async () => {
  const { code, data,msg } = await http.deleteChat({
    gid: chatGourpId.value,
    ids: [ actionItem.value.id]
  })
  if (code === 200 && data) {
    showDeleteConfirm.value = false
    chatList.value = chatList.value.filter(i => i.id !== actionItem.value.id)
    chatList.value = formatChatList(chatList.value)
  }
  proxy.$toast({
    message: msg
  })
}, 1000)


// 队列图片消息
function createRequest (fileObject) {
  return async () => {
    let params = {
      gid: chatGourpId.value,
      tuid: chatTargetInfo.value.uid,
      msg: '',
      attachments: [fileObject.file.id],
      key: encrypt(`${aesInfo.iv}${aesInfo.key}`)
    }
    if (chatList.value.length) {
      params.preTime = chatList.value[chatList.value.length - 1].ctime
    }
    const { code, data, msg } = await http.sendMsg(params)
    if (code === 200) {
      const updateAttachList = data.chatUserMsg.chatMsgList.filter(i => i.attachments)
      chatList.value.forEach(i => {
        const attachIndex = updateAttachList.findIndex(i => i.attachments[0].id === fileObject.file.id)
        if (attachIndex >= 0 && i.attachId === updateAttachList[attachIndex].attachments[0].id) {
          Object.assign(i, updateAttachList[attachIndex])
        }
      })
      data.chatUserMsg.chatMsgList.forEach(i => {
        if (i.msg) {
          const msg = aesDecrypt(i.msg, aesInfo.key, aesInfo.iv)
          i.msg = linkifyText(msg)
        }
      })
      let chatMsgList = data.chatUserMsg.chatMsgList.filter(i => !i.attachments)
      chatMsgList = formatChatList([  ...chatList.value, ...chatMsgList])
      
      chatList.value = [  ...chatMsgList]
      fetchTime.value = data.currentTime
    }
    if (code !== 200){
      fileObject.file.status = 'fail'
      fileObject.file.msg = msg
    }
    nextTick(() => {
      scrollToBottom()
    })
  }
}

async function afterSelectImage (file) {
  proxy.$ga('message_user_image')
  const files = isArray(file) ? file : [ file ]
  for (const item of files) {
    item.type = 1
    item.progress = 0
    item.status = 'uploading'
    await getImageDimensions(item)
  }
  const imgMsgList = files.map((i, index) => {
    return {
      gid: chatGourpId.value,
      fuid: uid.value,
      attachments: [{
        url: i.objectUrl,
        width: i.width,
        height: i.height
      }],
      ctime: Date.now(),
      file: i
    }
  })
  chatList.value = formatChatList([  ...chatList.value, ...imgMsgList])
  console.log(chatList.value)
  setTimeout(() => {
    scrollToBottom()
  }, 500)
  await UploadFile(files, 'chat', '', true, '', {
    gid: chatGourpId.value,
    tuid: chatTargetInfo.value.uid
  })
  
  imgMsgList.forEach(i => {
    console.log(i.file.status)
    if (i.file.status === 'complete') {
      queue.addRequest(createRequest(i))
    } else {
      i.file.msg = proxy.$t('chat.uploadFail')
    }
  })
}


async function modifyChatSetting () {
  proxy.$ga('message_user_setting', {
    "button_name": proxy.$t(`chat.${alreadyBlock.value ? 'openReceive' : 'closeReceive'}`)
  })
  const { code, data, msg } = await proxy.$http[alreadyBlock.value ? 'removeBlackListUser' : 'addBlackListUser']({
    id: chatTargetInfo.value.uid
  })
  if (code === 200) {
    alreadyBlock.value = !alreadyBlock.value
  }
  proxy.$toast({
    message: msg
  })
}


watch(attachments, (val) => {
  chatList.value.filter(i => i.attachments).forEach(imgMsg => {
    attachments.value.forEach(attach => {
      const { progress, status, path, previewUrl, objectUrl, id, msg } = attach
      if (imgMsg.attachments[0].url === objectUrl) {
        Object.assign(imgMsg, { 
          progress, 
          status, 
          path, 
          previewUrl, 
          objectUrl,
          attachId: id,
          msg
        })
      }
    })
  })
}, {
  immediate: true,
  deep: true
})

watch(() => props.modelValue, (val) => {
  visible.value = val
  if (val) {
    chatTargetInfo.value = { ...props.chatInfo }
    getChatList()
  } else {
    showDeleteConfirm.value = false
    chatList.value = []
    chatValue.value = ''
    finished.value = false
    fetchTime.value = false
    clearInterval(interval.value)
    interval.value = null
  }
})

watch(() => visible.value, (val) => {

  emit('update:modelValue', val)
})

</script>

<style lang="postcss" scoped>
.chat-drawer {
  :deep(.el-drawer__body) {
    margin: 0;
  }
}
.chat-room {
  position: relative;
  :deep(.van-list__finished-text) {
    display: none;
  }
  .chat-bar-more {
    display: flex;
    flex-flow: column wrap;
    align-items: flex-start;
    justify-content: center;
    padding: 8px 0;
    overflow: hidden;
    dt {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      height: 100%;
      font-size: 14px;
      padding: 11px 24px;
      cursor: pointer;
      &:empty {
        display: none;
      }
    }
    dt:hover {
      background-color: var(--background-light);
    }
  }
  .blocked-wrap {
    width: 792px;
    padding: 16px 0;
    margin: 0 auto;
    text-align: center;
    font-size: 14px;
    color: var(--color-text-disabled);
    background-color: var(--color-background-secondary);
  }
  .send-wrap {
    /* position: absolute;
    bottom: 48px;
    left: 50%;
    margin-left: -396px; */
    display: flex;
    flex-flow: column wrap;
    align-items: flex-end;
    width: 792px;
    margin: 0 auto;
    .send-wrap-b {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }
    .message-plugins {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;
    }
    .emoji-bar{
      cursor: pointer;
      font-size:14px;
      color:rgba(0, 0, 0, 0.55);
      margin-right: 12px;
      height: 24px;
    }
    .van-uploader {
      display: flex;
      align-items: center;
      height: 24px;
      :deep(.van-uploader__wrapper) {
        height: 24px;
        .van-uploader__input-wrapper {
          display: flex;
          align-items: center;
          .svg-icon {
            position: relative;
            color: var(--color-text-description);
          }
        }
      }
    }
    #emojiInput{
      width:100%;
      height:80px;
      background:#F9F9F9;
      max-length:20;
      padding:24px;
      border-radius: 12px;
      box-shadow: 0 0 0 0.33px rgb(0 0 0 / 12%);
    }
  }
  :deep(.el-textarea) {
    --el-font-size-base: 16px;
    --el-border-radius-base: 0;
    .el-textarea__inner {
      border-radius: 12px;
      background-color: #F9F9F9;
      box-sizing: border-box;
      padding: 24px;
      height: 180px !important;
      box-shadow: none;
      border: 1px solid var(--fill-divider-color, #DCDCDC);
    }
  }
  .el-button {
    --el-button-bg-color: var(--theme);
    --el-button-active-color: var(--theme);
    --el-color-primary-dark-2: var(--theme);
    --el-button-hover-bg-color: var(--theme);
    --el-button-disabled-bg-color: var(--theme-disabled);
    height: 38px;
    padding: 12px 24px;
    font-family: 'orbit-M';
    font-size: 14px;
    line-height: 14px;
    text-align: center;
    color: #FFFFFF;
    border: none;
    margin-top: 8px;
  }
}
:deep(.chat-scroll) {
  margin-bottom: 48px;
}
.title-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 792px;
  padding: 34px 0;
  margin: 0 auto;
  background-color: #FFF;
  box-shadow: 0 0.33px 0 0 rgb(0 0 0 / 12%);
  z-index: 30;
  .title {
    font-size: 24px;
    font-family: 'orbit-M';
    text-align: center;
  }
}
.reverse {
  flex-direction: row-reverse !important;
}
.flex-end {
  align-items: flex-end !important;
}
.msg-item {
  display: flex;
  flex-flow: column wrap;
  align-items: flex-start;
  justify-content: center;
  width: 792px;
  margin: 16px auto 0;
  padding: 0 24px;
  box-sizing: border-box;
  &-time {
    width: 100%;
    text-align: center;
    font-size: 14px;
    line-height: 100%;
    color: var(--text-hint);
    margin-bottom: 20px;
  }
  &-info {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    justify-content: flex-start;
    .avatar-block {
      flex-shrink: 0;
      width: 48px;
      height: 48px;
    }
    .reverse {
      margin-left: 0 !important;
      margin-right: 20px;
      .content,.private-image {
        border-radius: 8px 2px 8px 8px !important;
      }
    }
    .info {
      display: flex;
      flex-flow: row nowrap;
      align-items: flex-start;
      justify-content: flex-start;
      margin-left: 20px;
      .private-image-box {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        .icon-error {
          margin: 0 12px;
        }
        &-t {
          display: flex;
          flex-direction: row;
          align-items: flex-end;
        }
        p {
          text-align: right;
          margin-top: 12px;
          color: var(--color-text-disabled);
          &:empty {
            display: none;
          }
        }
      }
      .private-image {
        position: relative;
        display: flex;
        align-items: center;
        max-width: 240px;
        max-height: 400px;
        overflow: hidden;
        background-color: var(--color-background-tertiary);
        border-radius: 2px 8px 8px 8px;
        .ob-image{
          &:empty {
            width: 240px;
            height: 146px;
          }
        }
        .local-img {
          width: 100%;
          object-fit: contain;
          object-position: center;
        }
        .layer {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: var(--color-special-mask);
        }
        .van-circle {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .content {
        max-width: 400px;
        padding: 16px 24px;
        font-size: 16px;
        line-height: 20px;
        word-break: break-word;
        color: var(--text-primary);
        background-color: var(--theme-chat-background);
        border-radius: 2px 12px 12px 12px;
        white-space: pre-wrap;
        :deep(a) {
          text-decoration: underline;
        }
      }
      .chat-mate {
        background-color: #00000008;
      }
      .svg-icon {
        flex-shrink: 0;
        margin: 0 20px;
      }
    }
  }
}
.delete-content {
  box-sizing: border-box;
  width: 360px;
  margin: 16px 0 24px;
  font-size: 16px;
  line-height: 120%;
  text-align: center;
  word-break: break-word;
  padding: 24px 24px 0;
}
</style>